export default class ProductsFiltersBar {
    constructor() {
        this.settings = {
            el: document.querySelector('[data-block="products-archive"]')
        };
        this.bindUIActions();
        this.handleSubmission();
        this.handleCheckbox();
    }
    bindUIActions() {
        if (this.settings.el) {
            const filtersButton = document.querySelector('.js-products-filters-btn');
            const filtersBar = document.querySelector('.js-products-filters-bar');
            const filtersBarContent = document.querySelector('.js-products-filters-bar-content');
            const filtersBarClose = document.querySelector('.js-products-filters-bar-close');
            const filtersAccBtn = document.querySelectorAll('.js-products-filters-accordion-button');
            const sortButton = document.querySelector('.js-products-sort-btn');
            const sortBar = document.querySelector('.js-products-sort-bar');
            const sortBarClose = document.querySelector('.js-products-sort-bar-close');
            const sortAccBtn = document.querySelectorAll('.js-products-sort-accordion-button');

            // Handle adding applied filter count

            const filterInputs = Array.from(filtersBarContent.querySelectorAll('input.cursor-pointer'));

            // Count the check filters and make sure it's not the "All" for a section as this is effectively no filters so we
            // don't want count this
            const isCheckedCount = filterInputs.filter(element => element.checked && !element.id.startsWith('all-')).length;
            const filterCountElement = document.querySelector('.js-products-filters-count');

            if (isCheckedCount > 0) {
                filterCountElement.innerHTML = `<span class="absolute -top-2 -right-2 bg-jrbd-black text-white font-primary font-bold text-sm rounded-full w-7 h-7 flex items-center justify-center">${isCheckedCount}<span class="sr-only">filters applied</span></span>`;
            }

            if (filtersButton) {
                filtersButton.addEventListener('click', () => {
                    filtersBar.classList.toggle('open');
                });
            }

            if (filtersBarClose) {
                filtersBarClose.addEventListener('click', () => {
                    filtersBar.classList.toggle('open');
                });
            }

            filtersAccBtn.forEach(button => {
                button.addEventListener('click', () => {
                    const panel = button.nextElementSibling;
                    const arrow = button.querySelector('i');

                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                        arrow.classList.remove('transform');
                        arrow.classList.remove('rotate-180');
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + 'px';
                        arrow.classList.add('transform');
                        arrow.classList.add('rotate-180');
                    }
                });
            });

            if (sortButton) {
                sortButton.addEventListener('click', () => {
                    sortBar.classList.toggle('open');
                });
            }

            if (sortBarClose) {
                sortBarClose.addEventListener('click', () => {
                    sortBar.classList.toggle('open');
                });
            }

            sortAccBtn.forEach(button => {
                button.addEventListener('click', () => {
                    const panel = button.nextElementSibling;
                    const arrow = button.querySelector('i');

                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                        arrow.classList.remove('transform');
                        arrow.classList.remove('rotate-180');
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + 'px';
                        arrow.classList.add('transform');
                        arrow.classList.add('rotate-180');
                    }
                });
            });
        }
    }

    handleCheckbox() {
        const checkboxes = document.querySelectorAll('.js-products-filters-bar-content input[type="checkbox"]');
        checkboxes.forEach(box => {
            box.addEventListener('click', () => {
                const parent = box.closest('.accordion-panel');
                if (!parent) return;

                if (box.hasAttribute('id') && box.id.startsWith('all-')) {
                    // This must be the "All" checkbox
                    parent.querySelectorAll('input[type="checkbox"]').forEach(b => {
                        if (!b.id.startsWith('all-')) b.checked = false;
                    });
                } else {
                    // This is a standard checkbox.
                    parent.querySelector('[id^="all-"]').checked = false;
                }
            });
        });
    }

    // Handle filter form submission
    handleSubmission() {
        const filterForm = document.querySelector('form#category');
        if (!filterForm) return;

        filterForm.addEventListener('submit', e => {
            e.preventDefault();
            const parsedAction = filterForm.action.replace(/\?.*/g, '');
            const checked = filterForm.querySelectorAll('input:checked');

            if (checked.length === 0) {
                return;
            }

            let string = '?';

            checked.forEach((input, index) => {
                if (input.id.includes('all') && input.value == '') return;
                string += `${input.name}=${input.value}`;
                if (index < checked.length - 1) {
                    string += '&';
                }
            });
            window.location.href = parsedAction + string;
        });
    }
}
new ProductsFiltersBar();
